import {useEffect, useState} from 'react'

const useScrollHide = ({threshold = 60, delay = 1000} = {}) => {
    const [hidden, setHidden] = useState(false)
    const [ready, setReady] = useState(false) // delay giống BottomBar

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--header-visible-height',
            hidden ? '0px' : 'var(--header-height)'
        )
        document.documentElement.style.setProperty(
            '--bottom-bar-height',
            hidden ? '0px' : '60px'
        )
    }, [hidden])

    useEffect(() => {
        let isMounted = true
        const timer = setTimeout(() => {
            if (isMounted) setReady(true)
        }, delay)
        return () => {
            isMounted = false
            clearTimeout(timer)
        }
    }, [delay])

    useEffect(() => {
        let lastScroll = window.pageYOffset
        let ticking = false

        const handleScroll = () => {
            const currentScroll = window.pageYOffset
            const scrollHeight = document.documentElement.scrollHeight
            const windowHeight = window.innerHeight
            const isAtBottom = windowHeight + currentScroll >= scrollHeight - 5
            const scrollDelta = currentScroll - lastScroll

            if (isAtBottom || currentScroll <= threshold) {
                // ở bottom hoặc đang ở top → luôn hiển thị
                setHidden(false)
            } else if (scrollDelta > 0) {
                // scroll xuống và đã qua threshold → ẩn
                setHidden(true)
            } else if (scrollDelta < -30) {
                // chỉ hiện lại khi scroll lên ít nhất 30px (tùy chỉnh)
                setHidden(false)
            }

            lastScroll = currentScroll
            ticking = false
        }

        const debounceScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(handleScroll)
                ticking = true
            }
        }

        window.addEventListener('scroll', debounceScroll)
        return () => window.removeEventListener('scroll', debounceScroll)
    }, [threshold])

    return {hidden: hidden && ready}
}

export default useScrollHide